import { FC } from 'react';
import { getCellBackgroundStyle, RELIABLE_MIN_DIALOGS } from '../lib/heatmapColors';
import { LegendSwatch } from './LegendSwatch';

/** Подписи легенды шкалы (namespace-независимые). */
export type HeatmapLegendLabels = {
  /** Слабое влияние — нижний край шкалы */
  belowBaseline: string;
  /** Влияние около базовой доли — середина шкалы */
  nearBaseline: string;
  /** Наибольшее влияние — верхний край шкалы */
  aboveBaseline: string;
  /** Пояснение про ненадёжный срез; принимает число диалогов порога */
  unreliable: (minDialogs: number) => string;
};

type Props = {
  labels: HeatmapLegendLabels;
};

/**
 * Легенда шкалы тепловой матрицы. Образцы красятся тем же правилом, что и ячейки
 * ({@link getCellBackgroundStyle}) на краях шкалы — иначе легенда и матрица разошлись бы.
 */
export const HeatmapLegend: FC<Props> = ({ labels }) => (
  <div className="flex flex-wrap items-center gap-4">
    <LegendSwatch style={getCellBackgroundStyle(0, 1)} label={labels.belowBaseline} />
    <LegendSwatch label={labels.nearBaseline} />
    <LegendSwatch style={getCellBackgroundStyle(1, 1)} label={labels.aboveBaseline} />
    <span className="text-xs text-muted-foreground">{labels.unreliable(RELIABLE_MIN_DIALOGS)}</span>
  </div>
);
